<template>
  <svg class="icon"><use :xlink:href="`#i-${icon}`"></use></svg>
</template>

<script>
import './svg'
export default {
    name: 'g-icon',
    props: {
        icon: {
            default: '',
            type: String
        },
    }
}
</script>

<style>
.icon{
    width:1em;
    height:1em;
}
</style>